//faces

import female1 from "../assets/img/faces/1.jpg";
import female2 from "../assets/img/faces/2.jpg";
import female3 from "../assets/img/faces/3.jpg";
import female4 from "../assets/img/faces/4.jpg";
import female5 from "../assets/img/faces/5.jpg";
import female6 from "../assets/img/faces/6.jpg";
import female7 from "../assets/img/faces/7.jpg";
import female8 from "../assets/img/faces/8.jpg";
import female9 from "../assets/img/faces/9.jpg";
import female10 from "../assets/img/faces/10.jpg";
import female11 from "../assets/img/faces/11.jpg";
import female12 from "../assets/img/faces/12.jpg";
import female13 from "../assets/img/faces/13.jpg";
import female14 from "../assets/img/faces/14.jpg";
import female15 from "../assets/img/faces/15.jpg";
import female16 from "../assets/img/faces/16.jpg";
import female17 from "../assets/img/faces/17.jpg";
import female18 from "../assets/img/faces/profile.jpg";

import photo1 from "../assets/img/photos/1.jpg";
import photo2 from "../assets/img/photos/2.jpg";
import photo3 from "../assets/img/photos/3.jpg";
import photo4 from "../assets/img/photos/4.jpg";
import photo5 from "../assets/img/photos/5.jpg";
import photo6 from "../assets/img/photos/6.jpg";
import photo7 from "../assets/img/photos/7.jpg";
import photo8 from "../assets/img/photos/8.jpg";
import photo9 from "../assets/img/photos/9.jpg";
import photo10 from "../assets/img/photos/10.jpg";
import photo11 from "../assets/img/photos/11.jpg";
import photo12 from "../assets/img/photos/12.jpg";
import photo13 from "../assets/img/photos/13.jpg";
import photo14 from "../assets/img/photos/14.jpg";
import photo15 from "../assets/img/photos/15.jpg";
import photo16 from "../assets/img/photos/16.jpg";
import photo17 from "../assets/img/photos/17.jpg";
import photo18 from "../assets/img/photos/18.jpg";
import photo19 from "../assets/img/photos/19.jpg";
import photo20 from "../assets/img/photos/20.jpg";
import photo21 from "../assets/img/photos/21.jpg";
import photo22 from "../assets/img/photos/22.jpg";
import photo23 from "../assets/img/photos/23.jpg";
import photo24 from "../assets/img/photos/24.jpg";
import photo25 from "../assets/img/photos/25.jpg";
import photo26 from "../assets/img/photos/26.jpg";
import aboutmain from "../assets/img/photos/aboutmain.jpg";
import award1 from "../assets/img/photos/award.png";
import award2 from "../assets/img/photos/award1.png";
import award3 from "../assets/img/photos/award2.png";
import award4 from "../assets/img/photos/award3.png";
import blog from "../assets/img/photos/blog.jpg";
import blog1 from "../assets/img/photos/blog1.jpg";
import blog2 from "../assets/img/photos/blog2.jpg";
import blog3 from "../assets/img/photos/blog3.jpg";
import blog4 from "../assets/img/photos/blog4.jpg";
import blog5 from "../assets/img/photos/blog5.jpg";
import blog6 from "../assets/img/photos/blog6.jpg";
import compare1 from "../assets/img/photos/compare1.jpg";
import compare2 from "../assets/img/photos/compare2.jpg";
import country from "../assets/img/photos/countrybg.jpg";
import error from "../assets/img/photos/error.jpg";
import fileimage1 from "../assets/img/photos/fileimage1.jpg";
import fileimage2 from "../assets/img/photos/fileimage2.jpg";
import fileimage3 from "../assets/img/photos/fileimage3.jpg";
import fileimage4 from "../assets/img/photos/fileimage4.jpg";
import fileimage5 from "../assets/img/photos/fileimage5.jpg";
import gradient1 from "../assets/img/photos/gradient1.jpg";
import gradient2 from "../assets/img/photos/gradient2.jpg";
import gradient3 from "../assets/img/photos/gradient3.jpg";
import green from "../assets/img/photos/green.jpg";
import red from "../assets/img/photos/red.jpg";

//Ecommerce

import product1 from "../assets/img/ecommerce/1.jpg";
import product01 from "../assets/img/ecommerce/01.jpg";
import product2 from "../assets/img/ecommerce/2.jpg";
import product02 from "../assets/img/ecommerce/02.jpg";
import product3 from "../assets/img/ecommerce/3.jpg";
import product03 from "../assets/img/ecommerce/03.jpg";
import product4 from "../assets/img/ecommerce/4.jpg";
import product04 from "../assets/img/ecommerce/04.jpg";
import product5 from "../assets/img/ecommerce/5.jpg";
import product05 from "../assets/img/ecommerce/05.jpg";
import product6 from "../assets/img/ecommerce/6.jpg";
import product06 from "../assets/img/ecommerce/06.jpg";
import product7 from "../assets/img/ecommerce/7.jpg";
import product07 from "../assets/img/ecommerce/07.jpg";
import product8 from "../assets/img/ecommerce/8.jpg";
import product08 from "../assets/img/ecommerce/08.jpg";
import product9 from "../assets/img/ecommerce/9.jpg";
import product09 from "../assets/img/ecommerce/09.jpg";
import product10 from "../assets/img/ecommerce/10.jpg";
import product11 from "../assets/img/ecommerce/11.jpg";
import product12 from "../assets/img/ecommerce/12.jpg";
import product13 from "../assets/img/ecommerce/13.jpg";
import product14 from "../assets/img/ecommerce/14.jpg";
import product15 from "../assets/img/ecommerce/15.jpg";
import shirt1 from "../assets/img/ecommerce/shirt-1.png";
import shirt2 from "../assets/img/ecommerce/shirt-2.png";
import shirt3 from "../assets/img/ecommerce/shirt-3.png";
import shirt4 from "../assets/img/ecommerce/shirt-4.png";
import shirt5 from "../assets/img/ecommerce/shirt-5.png";

//Medaia

import media1 from "../assets/img/media/1.jpg";
import media2 from "../assets/img/media/2.jpg";
import media3 from "../assets/img/media/3.jpg";
import media4 from "../assets/img/media/4.jpg";
import media5 from "../assets/img/media/5.jpg";
import media6 from "../assets/img/media/6.jpg";
import media7 from "../assets/img/media/7.jpg";
import media8 from "../assets/img/media/8.jpg";
import media10 from "../assets/img/media/10.jpg";
import authentication from "../assets/img/media/authentication.png";
import bgimg from "../assets/img/media/bg-img.jpg";
import bgimg1 from "../assets/img/media/bg-img1.jpg";
import bgimg2 from "../assets/img/media/bg-img2.jpg";
import bgimg3 from "../assets/img/media/bg-img3.jpg";
import bgimg4 from "../assets/img/media/bg-img4.jpg";
import calendar from "../assets/img/media/calendar.png";
import climate from "../assets/img/media/climate.jpg";
import illustrate from "../assets/img/media/illustrate.png";
import illustrate1 from "../assets/img/media/illustrate1.png";
import illustrate2 from "../assets/img/media/illustrate2.png";

//svg
import accountant from "../assets/img/svgicons/accountant.svg";
import bannerimg from "../assets/img/svgicons/banner-img.svg";
import booking from "../assets/img/svgicons/booking.svg";
import briefing from "../assets/img/svgicons/briefing.svg";
import calendar1 from "../assets/img/svgicons/calendar.svg";
import calendar2 from "../assets/img/svgicons/calendar1.svg";
import chrome from "../assets/img/svgicons/chrome.svg";
import edge from "../assets/img/svgicons/edge.svg";
import email from "../assets/img/svgicons/email.svg";
import firefox from "../assets/img/svgicons/firefox.svg";
import group from "../assets/img/svgicons/group_presentation.svg";
import imac from "../assets/img/svgicons/imac.svg";
import invoice from "../assets/img/svgicons/invoice.svg";
import launch from "../assets/img/svgicons/launch.svg";
import letter from "../assets/img/svgicons/letter.svg";
import nodata from "../assets/img/svgicons/no-data.svg";
import note from "../assets/img/svgicons/note_taking.svg";
import notfound from "../assets/img/svgicons/notfound.svg";
import opera from "../assets/img/svgicons/opera.svg";
import notification from "../assets/img/svgicons/notification.svg";
import phonebook from "../assets/img/svgicons/phone-book.svg";
import project1 from "../assets/img/svgicons/project.svg";
import project2 from "../assets/img/svgicons/project2.svg";
import question from "../assets/img/svgicons/question.svg";
import report from "../assets/img/svgicons/report.svg";
import reward from "../assets/img/svgicons/reward.svg";
import rocket from "../assets/img/svgicons/rocket_launch.svg";
import safari from "../assets/img/svgicons/safari.svg";
import sales from "../assets/img/svgicons/sales-revenue.svg";
import settings from "../assets/img/svgicons/settings.svg";
import site from "../assets/img/svgicons/site.svg";
import translation from "../assets/img/svgicons/translation.svg";
import ucbrowser from "../assets/img/svgicons/uc-browser.svg";
import wave from "../assets/img/svgicons/wave.svg";

//png
import png1 from "../assets/img/png/1.png";
import png2 from "../assets/img/png/2.png";
import png501 from "../assets/img/png/501.png";
import account from "../assets/img/png/account.png";
import chatbg from "../assets/img/png/chatbg.png";
import chatbg2 from "../assets/img/png/chatbg2.png";
import circle11 from "../assets/img/png/ciecle111.png";
import circleimg from "../assets/img/png/circle-image1.png";
import circle from "../assets/img/png/circle.png";
import circle1 from "../assets/img/png/circle1.png";
import countrymap from "../assets/img/png/countrymap.png";
import countrymap1 from "../assets/img/png/countrymap1.png";
import dashboard8 from "../assets/img/png/dashboard8.png";
import gift from "../assets/img/png/gift.png";
import order from "../assets/img/png/order.png";
import visit from "../assets/img/png/visit.png";

//files

import doc from "../assets/img/files/doc.png";
import file from "../assets/img/files/file.png";
import file1 from "../assets/img/files/file1.png";
import file2 from "../assets/img/files/file2.png";
import folder from "../assets/img/files/folder.png";
import image from "../assets/img/files/image.png";
import ppt from "../assets/img/files/ppt.png";
import word from "../assets/img/files/word.png";
import zip from "../assets/img/files/zip.png";

import visa from "../assets/img/visa.png";
import mastercard from "../assets/img/mastercard.png";

//flags

import us from "../assets/img/flags/us_flag.jpg";
import italy from "../assets/img/flags/italy_flag.jpg";
import spain from "../assets/img/flags/spain_flag.jpg";
import india from "../assets/img/flags/india_flag.jpg";
import french from "../assets/img/flags/french_flag.jpg";
import mexico from "../assets/img/flags/mexico.jpg";
import singapore from "../assets/img/flags/singapore.jpg";
import poland from "../assets/img/flags/poland.jpg";
import austria from "../assets/img/flags/austria.jpg";
import russia from "../assets/img/flags/russia_flag.jpg";
import germany from "../assets/img/flags/germany_flag.jpg";
import argentina from "../assets/img/flags/argentina.jpg";
import brazil from "../assets/img/flags/brazil.jpg";
import uae from "../assets/img/flags/uae.jpg";
import china from "../assets/img/flags/china.jpg";
import uk from "../assets/img/flags/uk.jpg";
import malaysia from "../assets/img/flags/malaysia.jpg";
import canada from "../assets/img/flags/canada.jpg";

import firebase from "../assets/img/brand/1.png";
import react from "../assets/img/brand/2.png";

import favicon from "../assets/img/brand/trijazel-icon.png";
import logo from "../assets/img/brand/trijazel-logo.png";
import logowhite from "../assets/img/brand/logo-white.png";
import faviconwhite from "../assets/img/brand/favicon-white.png";
import hoa from "../assets/img/backgrounds/hoa.jpg";
import conferenceroom from "../assets/img/backgrounds/conferenceroom.jpeg";
export const imagesData = (idx: any) => {
  const images: any = {
    female1,
    female2,
    female3,
    female4,
    female5,
    female6,
    female7,
    female8,
    female9,
    female10,
    female11,
    female12,
    female13,
    female14,
    female15,
    female16,
    female17,
    female18,

    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8,
    photo9,
    photo10,
    photo11,
    photo12,
    photo13,
    photo14,
    photo15,
    photo16,
    photo17,
    photo18,
    photo19,
    photo20,
    photo21,
    photo22,
    photo23,
    photo24,
    photo25,
    photo26,
    aboutmain,
    award1,
    award2,
    award3,
    award4,
    blog,
    blog1,
    blog2,
    blog3,
    blog4,
    blog5,
    blog6,
    compare1,
    compare2,
    country,
    error,
    fileimage1,
    fileimage2,
    fileimage3,
    fileimage4,
    fileimage5,
    gradient1,
    gradient2,
    gradient3,
    green,
    red,

    product1,
    product01,
    product2,
    product02,
    product3,
    product03,
    product4,
    product04,
    product5,
    product05,
    product6,
    product06,
    product7,
    product07,
    product8,
    product08,
    product9,
    product09,
    product10,
    product11,
    product12,
    product13,
    product14,
    product15,
    shirt1,
    shirt2,
    shirt3,
    shirt4,
    shirt5,

    media1,
    media2,
    media3,
    media4,
    media5,
    media6,
    media7,
    media8,
    media10,
    authentication,
    bgimg,
    bgimg1,
    bgimg2,
    bgimg3,
    bgimg4,
    calendar,
    climate,
    illustrate,
    illustrate1,
    illustrate2,

    accountant,
    bannerimg,
    booking,
    briefing,
    calendar1,
    calendar2,
    chrome,
    edge,
    email,
    firefox,
    group,
    imac,
    invoice,
    launch,
    letter,
    nodata,
    note,
    notfound,
    notification,
    opera,
    phonebook,
    project1,
    project2,
    question,
    report,
    reward,
    rocket,
    safari,
    sales,
    settings,
    site,
    translation,
    ucbrowser,
    wave,

    png1,
    png2,
    png501,
    account,
    chatbg,
    chatbg2,
    circle11,
    circleimg,
    circle,
    circle1,
    countrymap,
    countrymap1,
    dashboard8,
    gift,
    order,
    visit,

    doc,
    file,
    file1,
    file2,
    folder,
    image,
    ppt,
    word,
    zip,

    visa,
    mastercard,

    us,
    italy,
    spain,
    india,
    french,
    mexico,
    singapore,
    poland,
    austria,
    russia,
    germany,
    argentina,
    brazil,
    uae,
    china,
    uk,
    malaysia,
    canada,

    firebase,
    react,
    favicon,
    faviconwhite,
    logo,
    logowhite,

    hoa,
    conferenceroom,
  };
  return images[idx];
};
